export default {
  menuList: [
    { label: '首页', index: 'home', level: 1 },
    {
      label: '营销干货及活动',
      index: '营销干货及活动',
      level: 1,
      children: [
        {
          title: '精选文章第一篇',
          index: '营销干货及活动1',
          level: 2,
          children: [
            { level: 3, title: '用户指南详解', index: '营销干货及活动-1-1' },
          ],
        },
        {
          title: '线上分享会',
          index: '1-营销干货及活动1-2',
          level: 2,
          children: [
            { level: 3, title: '线上分享会1', index: '1-1营销干货及活动-2-1' },
          ],
        },
        {
          title: '线下分享会',
          index: '1-1-3',
          level: 2,
          children: [
            {
              level: 3,
              title: '线下分享会1',
              index: '营销干货及活动1营销干货及活动-1-3-1',
              children: [
                {
                  level: 4,
                  title: '线上分享会1asda',
                  index: '1-1营销干货及活asdas动-2-1',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: '匠心未来',
      index: 'jiangxi3nweilai',
      level: 1,
      children: [{ level: 2, title: '用户指南详解', index: '1-1-1-1-2-3' }],
    },
    { title: '创意领域', index: 'chuangxinlingyu', level: 1 },
    {
      title: '用户中心',
      level: 1,
      index: 'jiangxin2weadasdilai',
      children: [{ level: 2, title: '用户指南详解', index: '1-1-1-1-09-1-1' }],
    },
    { title: '产品更新', index: 'jiangxinweilai', level: 1 },
    {
      title: '直播课程',
      index: 'jianas1dasdgxinweilai',
      level: 1,
      children: [{ level: 2, title: '用户指南详解', index: '1-1-1-1-9081203' }],
    },
    {
      title: '更多',
      index: 'jiaasdngxinweilai',
      level: 1,
      children: [{ level: 2, title: '用户指南详解', index: '1-1-1-1-1892' }],
    },
  ],
  contentData: {
    heightlight: [
      {
        url: 'https://jmy-pic.baidu.com/0/pic/18e6f2b7e0f92ecd34b92bfa2d3b264a.jpg@f_webp',
        title: '景德镇陶瓷一直被认为瓷中珍品，具有优良的质量和良好的收藏潜力。',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://jmy-pic.baidu.com/0/pic/18e6f2b7e0f92ecd34b92bfa2d3b264a.jpg@f_webp',
        title: '景德镇陶瓷一直被认为瓷中珍品，具有优良的质量和良好的收藏潜力。',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://jmy-pic.baidu.com/0/pic/18e6f2b7e0f92ecd34b92bfa2d3b264a.jpg@f_webp',
        title: '景德镇陶瓷一直被认为瓷中珍品，具有优良的质量和良好的收藏潜力。',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
    ],
    contentList: [
      {
        url: 'https://jmy-pic.baidu.com/0/pic/18e6f2b7e0f92ecd34b92bfa2d3b264a.jpg@f_webp',
        title: '景德镇陶瓷一直被认为瓷中珍品，具有优良的质量和良好的收藏潜力。',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://www.esteelauder.com.cn/media/export/cms_2.0/landing-page-2021/summer_pc_210630_01.jpg',
        title:
          '111雅诗兰黛Estee Lauder官方网站,为您甄选明星产品,更有独享套装,品质包装,尽显尊贵.雅诗兰黛官方网站,100%正品保证,同享专柜积分礼遇,24h在线购物!还有唇膏定制刻字服务',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://cdn.stocksnap.io/img-thumbs/280h/PB6TLGYIXH.jpg',
        title:
          '222鑫圣金业，是香港金银业贸易场81号行员，获发AA牌照，是中国知名的专业贵金属投资机构。秉承“客户至上·诚信为本”的经营理念，致力于网络化电子交易平台的建设，鑫圣取得突飞猛进的业绩',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://cdn.stocksnap.io/img-thumbs/280h/blue-swirl_1W1GIWBJTS.jpg',
        title: '333做什么生意最赚钱',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://b.bdstatic.com/boxlib/20210721/2021072114210069147033942.jpg',
        title:
          '4444在他乡挺好的 是由李漠执导，周雨彤、白宇帆、孙千、马思超、代云帆、金靖、泰乐主演，任素汐特别出演的都市话题剧',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://img0.baidu.com/it/u=2037664217,787517676&fm=253&fmt=auto&app=120&f=JPEG?w=600&h=337',
        title: '555女足综合:中国惨负巴西 瑞典爆冷美国',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://cdn.stocksnap.io/img-thumbs/280h/SHXPE6AGBB.jpg',
        title: '666束思霭束思霭',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://img1.baidu.com/it/u=2474413574,1584159743&fm=26&fmt=auto&gp=0.jpg',
        title:
          '777友和官方网站,网购电器及电子产品:智能手机丶美容及护理丶穿戴式装置丶电脑文仪丶数码影像丶电视影音丶家庭电器丶汽车用品。过万款产品,最快即日配送。',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://img0.baidu.com/it/u=1733823909,3947756380&fm=26&fmt=auto&gp=0.jpg',
        title:
          '888巴啦啦小魔仙 是奥飞娱乐股份有限公司制作出品的电视剧，由李思捷执导，齐圆、林杰利、王薇编剧，孙侨潞、黄安仪',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://b.bdstatic.com/boxlib/20210721/2021072114210069147033942.jpg',
        title:
          '999使用设计工具的好处在于，当这些项目材料同时呈现，能够帮助我们使用设计工具的好处在于，当这些项目材料同时呈现，能够帮助我们…',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://b.bdstatic.com/boxlib/20210721/2021072114210069147033942.jpg',
        title:
          '1010使用设计工具的好处在于，当这些项目材料同时呈现，能够帮助我们使用设计工具的好处在于，当这些项目材料同时呈现，能够帮助我们…',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
      {
        url: 'https://b.bdstatic.com/boxlib/20210721/2021072114210069147033942.jpg',
        title:
          '1111使用设计工具的好处在于，当这些项目材料同时呈现，能够帮助我们使用设计工具的好处在于，当这些项目材料同时呈现，能够帮助我们…',
        creator: '束思霭',
        create_time: '2021-06-25',
        uv: 187,
        need_zoom: 0,
        id: 123843,
      },
    ],
    isCta: 1,
  },
  recommendList: [
    {
      url: 'https://jmy-pic.baidu.com/0/pic/18e6f2b7e0f92ecd34b92bfa2d3b264a.jpg@f_webp',
      title: '景德镇陶瓷一直被认为瓷中珍品，具有优良的质量和良好的收藏潜力。',
      creator: '束思霭',
      create_time: '2021-06-25',
      uv: 187,
      need_zoom: 0,
      id: 123843,
    },
    {
      url: 'https://www.esteelauder.com.cn/media/export/cms_2.0/landing-page-2021/summer_pc_210630_01.jpg',
      title:
        '雅诗兰黛Estee Lauder官方网站,为您甄选明星产品,更有独享套装,品质包装,尽显尊贵.雅诗兰黛官方网站,100%正品保证,同享专柜积分礼遇,24h在线购物!还有唇膏定制刻字服务',
      creator: '束思霭',
      create_time: '2021-06-25',
      uv: 187,
      need_zoom: 0,
      id: 123843,
    },
    {
      url: 'https://cdn.stocksnap.io/img-thumbs/280h/PB6TLGYIXH.jpg',
      title:
        '鑫圣金业，是香港金银业贸易场81号行员，获发AA牌照，是中国知名的专业贵金属投资机构。秉承“客户至上·诚信为本”的经营理念，致力于网络化电子交易平台的建设，鑫圣取得突飞猛进的业绩',
      creator: '束思霭',
      create_time: '2021-06-25',
      uv: 187,
      need_zoom: 0,
      id: 123843,
    },
  ],
}
